import React from 'react';

const SuccessAlert = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Ikon Okej"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 2.3209C7.04121 2.3209 1.4 7.96211 1.4 14.9209C1.4 21.8797 7.04121 27.5209 14 27.5209C20.9588 27.5209 26.6 21.8797 26.6 14.9209C26.6 7.96211 20.9588 2.3209 14 2.3209ZM0 14.9209C0 7.18891 6.26801 0.920898 14 0.920898C21.732 0.920898 28 7.18891 28 14.9209C28 22.6529 21.732 28.9209 14 28.9209C6.26801 28.9209 0 22.6529 0 14.9209Z"
        fill="#277637"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.4397 9.60178C21.7868 9.97628 21.7868 10.5835 21.4397 10.958C21.4397 10.958 12.8938 20.2133 12.8375 20.2736C12.4892 20.6466 11.8776 20.5914 11.4713 20.1502L8.03833 16.4218C7.63205 15.9806 7.58504 15.3205 7.93332 14.9474C8.28161 14.5743 8.8933 14.6295 9.29958 15.0708L12.1978 18.2193L20.1831 9.60178C20.5301 9.22727 21.0927 9.22727 21.4397 9.60178Z"
        fill="#277637"
      />
      <defs></defs>
    </svg>
  );
};
export default SuccessAlert;
